<template>
    <div
        class="paciente-item md-layout-item md-small-size-100 md-medium-size-50 md-large-size-25 md-xlarge-size-25"
    >
        <modal
            v-if="showModalComments"
            @close="modalCommentsHide"
            modalSize="modal-container-lg"
        >
            <template slot="header">
                <h4 class="modal-title">{{ $t("add_comment") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="modalCommentsHide"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <nav-tabs-card>
                    <template slot="content">
                        <md-tabs class="md-success" md-alignment="left">
                            <md-tab
                                id="tab-patient-last-minute"
                                :md-label="$t('add_comment')"
                                md-icon="comments"
                            >
                                <div class="md-layout">
                                    <md-field>
                                        <label>{{ $t("add_comment") }}</label>
                                        <md-textarea
                                            v-model="patientComment"
                                            md-autogrow
                                        ></md-textarea>
                                    </md-field>
                                </div>
                            </md-tab>
                            <md-tab
                                id="tab-patient-advanced-charts"
                                :md-label="$t('comment_history')"
                                md-icon="access_time"
                            >
                                <div class="text-left">
                                    <ul class="timeline timeline-simple">
                                        <li
                                            class="timeline-inverted"
                                            v-for="comentario in paciente.comentarios"
                                            v-bind:key="comentario.id"
                                        >
                                            <div class="timeline-badge success">
                                                <span
                                                    class="icon-ic-nota fs-20"
                                                ></span>
                                            </div>
                                            <div class="timeline-panel">
                                                <div class="timeline-body">
                                                    <p>
                                                        {{
                                                            comentario.comentario
                                                        }}
                                                    </p>
                                                </div>
                                                <h6>
                                                    <h6 class="text-bold">
                                                        <i class="ti-time"></i>
                                                        {{
                                                            $moment(
                                                                comentario.fechaCreacion
                                                            ).format(
                                                                "Y-MM-DD HH:mm:ss"
                                                            )
                                                        }}
                                                    </h6>
                                                </h6>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </md-tab>
                        </md-tabs>
                    </template>
                </nav-tabs-card>
            </template>

            <template slot="footer">
                <md-button
                    class="md-danger md-simple"
                    @click="modalCommentsHide"
                    >{{ $t("cancel") }}
                </md-button>
                <md-button @click="saveComment(paciente.id)" class="md-success"
                    >{{ $t("save") }}
                </md-button>
            </template>
        </modal>
        <modal
            v-if="showModal"
            @close="modalHide"
            modalSize="modal-container-xl"
        >
            <template slot="header">
                <h4 class="modal-title">
                    {{ $t("paciente.room") }} {{ paciente.numeroHabitacion }}
                </h4>
            </template>
            <template slot="body">
                <nav-tabs-card>
                    <template slot="content">
                        <md-tabs class="md-success" md-alignment="left">
                            <md-tab
                                id="tab-patient-last-minute"
                                :md-label="$t('week_chart')"
                                md-icon="alarm"
                            >
                                <div class="md-layout">
                                    <div class="md-layout-item text-right">
                                        <week-chart-hml
                                            :paciente="id"
                                        ></week-chart-hml>
                                    </div>
                                </div>
                            </md-tab>
                            <md-tab
                                id="tab-patient-advanced-charts"
                                :md-label="$t('advanced_charts')"
                                md-icon="equalizer"
                            >
                                <advanced-chart :paciente="id"></advanced-chart>
                            </md-tab>
                            <md-tab
                                v-if="paciente.allowPatientLocation"
                                id="tab-patient-location-charts"
                                :md-label="$t('location')"
                                md-icon="location_on"
                            >
                                <location :data="paciente.estado"></location>
                            </md-tab>
                            <md-tab
                                v-if="permissionsAdminCentro"
                                id="tab-patient-info"
                                :md-label="$t('edit_patient')"
                                md-icon="edit"
                            >
                                <form ref="form">
                                    <patient-form
                                        @on-validated="onFormValidated"
                                        ref="formulario"
                                        :paciente.sync="paciente"
                                    >
                                    </patient-form>
                                </form>
                                <br />
                            </md-tab>
                        </md-tabs>
                    </template>
                </nav-tabs-card>
            </template>
            <template slot="footer">
                <div class="md-layout md-alignment-bottom-left">
                    <md-button v-if="permissionsAdminCentro" class="md-danger pull-left" @click="unsubscribe">
                        {{ $t("unsubscribe") }}
                    </md-button>
                </div>
                <div class="md-layout md-alignment-bottom-right">
                    <md-button class="md-danger md-simple" @click="modalHide"
                        >{{ $t("cancel") }}
                    </md-button>
                    <md-button v-if="permissionsAdminCentro" @click="submit()" class="md-success"
                        >{{ $t("save") }}
                    </md-button>
                </div>
            </template>
        </modal>
        <div class="patient-card md-elevation-6">
            <div
                v-if="fullInfo"
                :class="displayInfo.leftColor"
                class="patient-panel w25 left"
            >
                <div class="text-center status" v-if="!showOptimalPos">
                    <span class="estado">
                        <img
                            :src="displayInfo.leftIcon"
                            v-if="displayInfo.showLeftIcon"
                            style="height: 80px; width: 52px"
                        />
                    </span>
                    <span
                        style="font-size: 16px"
                        v-if="displayInfo.showLeftTimer"
                        >{{ displayInfo.leftTime }}</span
                    >
                </div>

                <div class="text-center status" v-if="showOptimalPos">
                    <span class="estado">
                        <img
                            :src="getRecommendedPosition()"
                            style="height: 80px; width: auto"
                        />
                    </span>
                    <span style="font-size: 16px">{{
                        $t("paciente.recomended_position")
                    }}</span>
                </div>
            </div>
            <div
                class="patient-panel w75 right"
                v-bind:class="{ w100: !fullInfo }"
            >
                <div class="relative-panel">
                    <div @click="openModal(paciente.id)" class="levels">
                        <div
                            class="level"
                            :class="clase"
                            v-for="(clase, i) in displayInfo.rightColors"
                            :key="i"
                        ></div>
                    </div>
                    <div class="panel-overflow white">
                        <div @click="openModal(paciente.id)" class="level">
                            <span style="font-size: larger"
                                >{{ $t("paciente.room")
                                }}{{ paciente.numeroHabitacion }}</span
                            >
                            <span v-if="fullInfo" class="right">
                                <i
                                    class="fas fa-exclamation-triangle fa-2x"
                                    v-if="displayInfo.caca"
                                ></i>
                                &nbsp;
                                <i
                                    v-if="paciente.noUrineAlarm"
                                    class="fas fa-tint-slash fa-2x"
                                ></i>
                            </span>
                        </div>
                        <div @click="openModal(paciente.id)" class="level">
                            <span class="title_status">
                                {{ displayInfo.status }}
                                <span v-if="displayInfo.showRightTimer">
                                    {{ displayInfo.rightTime }}
                                </span>
                            </span>
                        </div>
                        <div class="level">
                            <span
                                @click="openModal(paciente.id)"
                                class="small-text"
                            >
                                {{ displayInfo.name }}
                            </span>
                            <span
                                v-if="permissionsAdminCentro"
                                v-show="!esIOS"
                                @click="openModalComments(paciente.id)"
                                class="pull-right fs-30"
                            >
                                <md-icon style="color: white !important"
                                    >edit</md-icon
                                >
                                <md-tooltip md-direction="bottom">{{
                                    $t("add_note")
                                }}</md-tooltip>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import { isIOS } from "mobile-device-detect";

import { authHeader } from "../../helpers/auth-header";
import Modal from "../Modal";
import NavTabsCard from "../Cards/NavTabsCard";
import advancedChart from "./advancedChart";
import patientForm from "./patientForm";
import weekChartHml from "./weekChartHml";
import { handleResponse } from "../../helpers/handle-response";
//posiciones
import andador from "../../assets/img/bm andador.png";
import dcha from "../../assets/img/b Tumb dcha.png";
import DchaCaraAbajo from "../../assets/img/b tum dcha abajo.png";
import Desconectado from "../../assets/img/bm descon.png";
import izq from "../../assets/img/b tum izq.png";
import IzqCaraAbajo from "../../assets/img/b tum izq abaj.png";
import pie from "../../assets/img/bm pie.png";
import recostado from "../../assets/img/bm recostado.png";
import sentado from "../../assets/img/bm sentado.png";
import supino from "../../assets/img/b t supino.png";
import nonet from "../../assets/img/bm nnet.png";
//Recomended positions
import reco_DchaCaraAbajo from "../../assets/img/V lat dcha.png";
import reco_IzqCaraAbajo from "../../assets/img/V lat Izq.png";
import reco_supino from "../../assets/img/V supino.png";
import Location from "./location.vue";

let BACKEND_API = process.env.VUE_APP_BACKEND_API;

export default {
    name: "patient",
    props: {
        permissionsAppQR: {
            type: Boolean,
            default: false,
        },
        permissionsAdminCentro: {
            type: Boolean,
            default: false,
        },
        permissionsAdminCadena: {
            type: Boolean,
            default: false,
        },
        objeto: {
            type: Object,
            default: function () {
                return {};
            },
            require: true,
        },
        fullInformation: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        parsePatientFullName: function () {
            let fullName = this.paciente.nombre + " " + this.paciente.apellidos;
            if (fullName.length > 20) {
                return fullName.substring(0, 15) + "...";
            } else {
                return fullName;
            }
        },
        displayInfo() {
            let paciente = this.paciente;
            let data = {
                caca: false,
                name: this.parsePatientFullName,
                leftColor: "bg-grey",
                rightColors: [],
                status: "",
                leftIcon: null,
                leftTime: "",
                rightTime: "",
                showLeftTimer: false,
                showRightTimer: false,
                showLeftIcon: false,
                estaBocaAbajo: false,
            };

            //Si el paciente no tiene info, devuelvo el apagado
            if (!paciente.estado) {
                data.leftColor = "bg-grey";
                data.rightColors.push("bg-grey");
                data.rightColors.push("bg-grey");
                data.rightColors.push("bg-grey");
                data.status = this.$root.$t("off");
                if (!paciente.allowActivityTracking) {
                    data.showLeftIcon = false;
                    data.showLeftTimer = false;
                }
                data.leftIcon = null;
                return data;
            }

            //Logica CACA
            if (this.paciente.estado) {
                if (paciente.estado.resistive_event_type == 4) {
                    data.caca = true;
                }
            }

            //icono
            let defaultIcon = Desconectado;

            //logica colores
            if (!paciente.sensor) {
                data.leftColor = "bg-not-assigned";
                data.status = this.$root.$t("not_assigned");
                data.rightColors.push("bg-not-assigned");
                data.rightColors.push("bg-not-assigned");
                data.rightColors.push("bg-not-assigned");
            }
            if (
                paciente.sensor &&
                (paciente.estado.tipo === "SOFF" ||
                    paciente.estado.tipo === "NNET")
            ) {
                data.leftColor = "bg-grey";
                data.rightColors.push("bg-grey");
                data.rightColors.push("bg-grey");
                data.rightColors.push("bg-grey");
                if (paciente.estado.tipo == "SOFF") {
                    data.status = this.$root.$t("off");
                }
                if (paciente.estado.tipo == "NNET") {
                    data.status = this.$root.$t("out_of_range");
                }
            }

            if (paciente.estado.estado_filtrado == 60) {
                defaultIcon = nonet;
            }
            if (paciente.estado.estado_filtrado == 50) {
                defaultIcon = null;
            }

            //Niveles
            if (
                paciente.sensor &&
                paciente.estado &&
                paciente.estado.estado_filtrado < 50
            ) {
                if (paciente.estado.estado_filtrado !== null) {
                    let estado_filtrado = paciente.estado.estado_filtrado;
                    if (paciente.estado.estado_filtrado >= 2) {
                        //Seco

                        data.showLeftTimer = true;
                        if (paciente.currentPosition) {
                            data.showLeftIcon = true;
                            if (
                                paciente.currentPosition.vertical_position === 1
                            ) {
                                //TUMBADO
                                let showTime = false;
                                //Pillo p horizontal
                                if (
                                    paciente.currentPosition
                                        .rotation_position === 1
                                ) {
                                    //LATERAL_DHCA
                                    defaultIcon = dcha;
                                    showTime = true;
                                }
                                if (
                                    paciente.currentPosition
                                        .rotation_position === 2
                                ) {
                                    //SUPINO
                                    defaultIcon = supino;
                                    showTime = true;
                                }
                                if (
                                    paciente.currentPosition
                                        .rotation_position === 3
                                ) {
                                    //LATERAL_IZQ
                                    defaultIcon = izq;
                                    showTime = true;
                                }
                                if (
                                    paciente.currentPosition
                                        .rotation_position === 4
                                ) {
                                    //CARA_ABAJO_IZQ
                                    defaultIcon = IzqCaraAbajo;
                                    data.estaBocaAbajo = true;
                                }
                                if (
                                    paciente.currentPosition
                                        .rotation_position === 5
                                ) {
                                    //CARA_ABAJO_DCHA
                                    defaultIcon = DchaCaraAbajo;
                                    data.estaBocaAbajo = true;
                                }

                                if (paciente.rotationAlarm) {
                                    if (showTime) {
                                        data.leftTime = this.convertTime(
                                            paciente.timeInPosition * 60
                                        );
                                    }
                                }
                            }
                            if (
                                paciente.currentPosition.vertical_position === 2
                            ) {
                                //RECOSTADO
                                defaultIcon = recostado;
                            }
                            if (
                                paciente.currentPosition.vertical_position === 3
                            ) {
                                //SENTADO
                                defaultIcon = sentado;
                            }
                            if (
                                paciente.currentPosition.vertical_position === 4
                            ) {
                                //ERGUIDO
                                defaultIcon = pie;
                            }
                            if (
                                paciente.currentPosition.vertical_position === 5
                            ) {
                                //ANDADOR
                                defaultIcon = andador;
                            }
                            if (
                                paciente.currentPosition.vertical_position === 0
                            ) {
                                //NO_DISPONIBLE
                                defaultIcon = null;
                            }
                        }
                    }
                    if (estado_filtrado == 0) {
                        data.leftColor = "bg-yellow";
                        data.status = this.$root.$t("disconnected");
                        data.rightColors.push("bg-yellow");
                        data.rightColors.push("bg-yellow");
                        data.rightColors.push("bg-yellow");
                        //defaultIcon = deson;
                        data.showLeftIcon = true;
                    }
                    if (
                        estado_filtrado == 1 ||
                        estado_filtrado == 2 ||
                        estado_filtrado == 3
                    ) {
                        data.status = this.$root.$t("dry");
                        if (paciente.lastUrineTime) {
                            if (paciente.noUrineAlarm) {
                                let curMilis = this.$moment(new Date()).format(
                                    "x"
                                );
                                let milis = this.$moment(
                                    paciente.lastUrineTime
                                ).format("x");
                                let calc = (curMilis - milis) / 1000;
                                data.rightTime = this.convertTime(calc);
                                if (calc > 0) {
                                    data.showRightTimer = true;
                                }
                            }
                        }

                        data.rightColors.push("bg-celeste");
                        data.rightColors.push("bg-celeste");
                        data.rightColors.push("bg-celeste");
                    }

                    if (!paciente.noUrineAlarm) {
                        if (estado_filtrado == 3) {
                            data.status = this.$root.$t("time_wet");
                            data.showRightTimer = false;
                            data.rightTime = this.convertTime(
                                paciente.estado.time_soiled
                            );
                            data.rightColors = [];
                            data.rightColors.push("bg-celeste");
                            data.rightColors.push("bg-celeste");
                            data.rightColors.push("bg-blue");
                        }
                    }

                    if (estado_filtrado == 4) {
                        data.status = this.$root.$t("time_wet");
                        data.showRightTimer = true;
                        data.rightTime = this.convertTime(
                            paciente.estado.time_soiled
                        );
                        data.rightColors.push("bg-celeste");
                        data.rightColors.push("bg-blue");
                        data.rightColors.push("bg-blue");
                    }
                    if (estado_filtrado == 5) {
                        data.status = this.$root.$t("time_wet");
                        data.showRightTimer = true;
                        data.rightTime = this.convertTime(
                            paciente.estado.time_soiled
                        );
                        data.rightColors.push("bg-blue");
                        data.rightColors.push("bg-blue");
                        data.rightColors.push("bg-blue");
                    }
                    if (estado_filtrado == 6) {
                        data.leftColor = "bg-yellow";
                        data.status = this.$root.$t("error");
                        data.rightColors.push("bg-yellow");
                        data.rightColors.push("bg-yellow");
                        data.rightColors.push("bg-yellow");
                        //defaultIcon = deson;
                        data.showLeftIcon = true;
                    }
                    //Alarmas
                    if (
                        estado_filtrado !== 0 &&
                        paciente.estado.tipo !== "SOFF" &&
                        paciente.estado.tipo !== "NNET"
                    ) {
                        if (paciente.noUrineAlarm) {
                            if (paciente.noUrine) {
                                data.rightColors = [];
                                data.rightColors.push("bg-red");
                                data.rightColors.push("bg-red");
                                data.rightColors.push("bg-red");
                            }
                        }
                    }

                    if (
                        estado_filtrado !== 0 &&
                        paciente.estado.tipo !== "SOFF" &&
                        paciente.estado.tipo !== "NNET"
                    ) {
                        if (paciente.rotationAlarm) {
                            if (data.leftColor !== "bg-yellow") {
                                data.leftColor = "bg-green";
                                if (paciente.rotation) {
                                    data.leftColor = "bg-red";
                                }
                            }
                            if (data.estaBocaAbajo) {
                                data.leftColor = "bg-red";
                            }
                        }
                    }
                    //Error contacto
                    if (paciente.estado.contact_error) {
                        data.status = this.$root.$t("error_contacto");
                    }
                }
            }

            if (!paciente.allowActivityTracking) {
                data.showLeftIcon = false;
                data.showLeftTimer = false;
            }

            data.leftIcon = defaultIcon;
            return data;
        },
    },
    components: {
        Modal,
        NavTabsCard,
        advancedChart,
        weekChartHml,
        patientForm,
        Location,
    },
    data() {
        return {
            esIOS: isIOS,
            showOptimalPos: false,
            refreshInterval: null,
            refreshPositionInterval: null,
            patientComment: "",
            formValidated: null,
            selectedDate: new Date(),
            selected: [],
            body: {},
            id: null,
            item: null,
            itemList: [],
            formData: [],
            showModal: false,
            showModalComments: false,
            fullInfo: this.fullInformation,
            paciente: this.objeto,
            datosFormulario: {},
            chartLegend: [],
        };
    },
    methods: {
        getRecommendedPosition() {
            if (this.paciente.recommendedPosition === 1) {
                return reco_DchaCaraAbajo;
            }
            if (this.paciente.recommendedPosition === 2) {
                return reco_supino;
            }
            if (this.paciente.recommendedPosition === 3) {
                return reco_IzqCaraAbajo;
            }
        },
        changeViewToRecomendedPos() {
            if (this.paciente.sensor && this.paciente.estado) {
                if (
                    this.paciente.estado.tipo !== "SOFF" &&
                    this.paciente.estado.tipo !== "NNET"
                ) {
                    if (this.paciente.estado.estado_filtrado > 0) {
                        if (this.paciente.rotationAlarm) {
                            if (this.paciente.rotation) {
                                this.showOptimalPos = !this.showOptimalPos;
                                return;
                            }
                        }
                    }
                }
            }
            this.showOptimalPos = false;
        },
        convertTime(seconds) {
            var minutes = Math.floor(seconds / 60);
            var hours = "";
            if (minutes > 59) {
                hours = Math.floor(minutes / 60);
                //hours = (hours >= 10) ? hours : "0" + hours;
                minutes = minutes - hours * 60;
                minutes = minutes >= 10 ? minutes : "0" + minutes;
            }
            seconds = Math.floor(seconds % 60);
            seconds = seconds >= 10 ? seconds : "0" + seconds;
            if (hours != "") {
                return hours + ":" + minutes + "";
            }
            return minutes + " min";
            /*
                let tt = time / 60; //segundos
                if (tt < 60) {
                    return tt.toFixed(0) + " min";
                } else {
                    return (tt / 60).toFixed(0) + "h";
                }
                 */
        },
        destroy() {
            this.patientComment = "";
            this.formValidated = null;
            this.selectedDate = new Date();
            this.selected = [];
            this.body = {};
            this.id = null;
            this.item = null;
            this.itemList = [];
            this.formData = [];
            this.showModal = false;
            this.showModalComments = false;
            this.fullInfo = null;
            this.paciente = null;
            this.chartLegend = [];
            this.datosFormulario = {};
        },
        onFormValidated(model) {
            this.datosFormulario = { ...this.datosFormulario, ...model };
        },
        unsubscribe() {
            this.$swal({
                title: this.$root.$t("are_you_sure"),
                text: this.$root.$t("you_cannot_revert_the_operation"),
                type: "warning",
                showCancelButton: true,
                closeOnClickOutside: false,
                confirmButtonText: this.$root.$t("yes"),
                cancelButtonText: this.$root.$t("no"),
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-danger",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    fetch(
                        `${BACKEND_API}/api/pacientes/baja/` + this.paciente.id,
                        {
                            method: "GET",
                            headers: authHeader(),
                        }
                    )
                        .then(handleResponse)
                        .then((response) => {
                            this.showModal = false;
                            this.$emit("fetchData");
                            this.$swal(
                                this.$root.$t("patient_unsubscribed"),
                                "",
                                "success"
                            );
                        });
                } else {
                }
            });
        },
        submit() {
            this.$refs["formulario"].validate().then((res) => {
                if (res) {
                    if (!this.paciente) {
                        this.new(this.datosFormulario);
                    } else {
                        this.edit(this.datosFormulario);
                    }
                }
            });
        },
        edit(data) {
            let self = this;
            fetch(`${BACKEND_API}/api/pacientes/edit/` + data.id, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify(data),
            })
                .then(handleResponse)
                .then(function (response) {
                    if (response.error) {
                        self.$notify({
                            message: self.$root.$t("error_formulario"),
                            icon: "warning",
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "warning",
                        });
                    } else {
                        self.modalHide();
                        self.$emit("fetchData");
                        self.$notify({
                            message: self.$root.$t("paciente_actualizado"),
                            icon: "add_alert",
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                    }
                });
        },
        new(data) {
            this.id = null;
            fetch(`${BACKEND_API}/api/pacientes/new`, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify(data),
            })
                .then(handleResponse)
                .then((response) => {
                    if (response.error) {
                        self.$notify({
                            message: self.$root.$t("error_formulario"),
                            icon: "warning",
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "warning",
                        });
                    } else {
                        self.modalHide();
                        self.$emit("fetchData");
                        self.$notify({
                            message: self.$root.$t("paciente_creado"),
                            icon: "add_alert",
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                    }
                });
        },
        saveComment(id) {
            let self = this;
            fetch(`${BACKEND_API}/api/pacientes/comment/` + id, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify({ comment: this.patientComment }),
            })
                .then(handleResponse)
                .then((response) => {
                    this.$emit("fetchData");
                    self.modalCommentsHide();
                });
        },
        openModal(id) {
            if (this.esIOS) {
                return;
            }
            //if (this.permissionsAdminCentro) {
                this.id = id;
                this.datosFormulario = { ...{}, ...this.paciente };
                this.formConfig();
                this.showModal = true;
            //}
        },
        openModalComments(id) {
            if (this.esIOS) {
                return;
            }
            this.patientComment = "";
            this.showModalComments = true;
        },
        modalCommentsHide() {
            this.showModalComments = false;
        },
        modalHide() {
            this.showModal = false;
        },
        formConfig() {
            fetch(`${BACKEND_API}/api/pacientes/prepare?id=` + this.id, {
                method: "GET",
                headers: authHeader(),
            })
                .then((response) => response.json())
                .then((data) => (this.formData = data[1]));
        },
        fetch() {
            let self = this;
            fetch(`${BACKEND_API}/api/pacientes/view/` + this.paciente.id, {
                method: "GET",
                headers: authHeader(),
            })
                .then((response) => response.json())
                .then(function (data) {
                    self.paciente = data.paciente;
                });
        },
    },
    destroyed() {
        clearInterval(this.refreshInterval);
        clearInterval(this.refreshPositionInterval);
        this.patientComment = null;
        this.formValidated = null;
        this.selectedDate = null;
        this.selected = null;
        this.body = null;
        this.id = null;
        this.item = null;
        this.itemList = null;
        this.formData = null;
        this.showModal = null;
        this.showModalComments = null;
        this.fullInfo = null;
        this.paciente = null;
        this.datosFormulario = null;
        this.chartLegend = null;
    },
    created() {
        let self = this;
        this.refreshInterval = setInterval(function () {
            self.fetch();
        }, 60000);
        this.refreshPositionInterval = setInterval(function () {
            self.changeViewToRecomendedPos();
        }, 2000);
    },
};
</script>

<style scoped>
.estado {
    height: 80px;
    display: block;
    line-height: 80px;
}

.estado img {
    vertical-align: middle;
}

.patient-panel {
    color: white !important;
}

.bg-grey {
    background-color: #9e9e9e;
}

.bg-red {
    background-color: red;
}

.paciente-item {
    padding: 5px !important;
}

.big-text {
    font-size: 20px;
}

.bg-error-conexion {
    background-color: orange !important;
}

.white {
    color: white;
}

.error-conexion {
    color: orange !important;
}

.small-text {
    font-size: 16px;
}

.left {
    float: left;
}

.right {
    float: right;
}

.status {
    margin-top: 15px;
}

.status i {
    display: block;
    width: 100%;
}

.bg-yellow {
    background-color: #ffdf00 !important;
}

.bg-celeste {
    background-color: #c5cae9 !important;
}

.bg-blue {
    background-color: #3f51b5 !important;
}

.bg-grey-500 {
    background-color: #949494;
}

.bg-not-assigned {
    background-color: #616161 !important;
}

.bg-out-of-range {
    background-color: #9e9e9e !important;
}

.patient-card {
    cursor: pointer;
    height: 100%;
    padding: 0 !important;
    font-weight: 400;
    display: -ms-flexbox;
    display: flex;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 0.25rem;
}

.clear {
    clear: both;
}

.w25 {
    width: 25%;
}

.w75 {
    width: 75%;
}

.w100 {
    width: 100%;
}

.patient-panel {
    display: block;
    height: 120px !important;
    margin: 0px !important;
}

.relative-panel {
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
}

.levels {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}

.panel-overflow {
    position: absolute;
    padding: 10px;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

.bg-green {
    background-color: #45a54e;
}

.level {
    width: 100%;
    height: 40px;
}

.text-bold {
    font-weight: bold;
}

.text-left {
    text-align: left;
}

.md-button {
    min-width: 1%;
}

.fs-30 {
    font-size: 30px !important;
}

.fs-20 {
    font-size: 20px !important;
}

.title_status {
    font-size: x-large;
}
</style>
